import React from 'react';
import { Container} from 'react-bootstrap';

import authbg from '../../assets/img/oasis/loginbg.png';

const AuthLayout = ({ children }) => {
    return (
        <Container
            className="d-flex flex-column justify-content-center align-items-center vh-70 py-4 position-relative"
            style={{
                backgroundImage: `url(${authbg})`,
                backgroundSize: 'contain',
                objectFit:'contain',
                backgroundPosition: 'center',


            }}
        >

            <div
                className="position-absolute top-0 start-0 w-100 h-50"
           
            ></div>


            <div className="w-100 position-relative z-1" style={{ maxWidth: '500px' }}>
                {children}
            </div>
        </Container>
    );
};

export default AuthLayout